import {createSlice} from '@reduxjs/toolkit'

const initialState: any = {
  isCardUpdated: false,
  // Bumped whenever a board column is created/changed from a place that
  // can't reach the board page's own column state (e.g. the create-task
  // -from-checklist modal). Board.tsx watches it to refetch its columns so
  // a column added from the modal renders on the kanban behind it.
  columnUpdatedAt: 0,
}

export const lastUpdateSlice = createSlice({
  name: 'last-update',
  initialState,
  reducers: {
    setIsCardUpdated: (state, action) => {
      state.isCardUpdated = action.payload
    },
    setColumnUpdatedAt: (state, action) => {
      state.columnUpdatedAt = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {setIsCardUpdated, setColumnUpdatedAt} = lastUpdateSlice.actions

export default lastUpdateSlice.reducer
